<template>
  <div class="col-lg col-md-6 mb-28" v-if="data">
    <div class="uc-card card-height--same">
      <img
        @error="replaceByDefault"
        :src="data.image"
        class="uc-card-img"
        style="height: 157px; object-fit: cover"
        loading="lazy"
      />

      <div class="uc-card_body">
        <div class="uc-subtitle mb-8">{{ data.timeAgo }}</div>
        <a
          :href="data.permalink"
          target="_blank"
          class="uc-btn btn-inline color-black"
        >
          <p style="word-break: break-word">
            {{ data.text | truncate(180) }}
          </p>
        </a>
        <div class="d-flex align-items-center mt-auto">
          <img
            :src="`/site/templates/dist/images/social/${data.icon}`"
            class="mr-12"
            loading="lazy"
          />
          <a :href="data.socialUrl" target="_blank">
            {{ data.socialNameDisplay }}
          </a>
        </div>
      </div>
    </div>
  </div>
  <div v-else></div>
</template>
<script>
export default {
  props: ["data"],
  methods: {
    replaceByDefault: function (el) {
      console.log("error");
    },
  },
};
</script>
